import PropTypes from "prop-types";
import React from "react";

/**
 * Description placeholder
 * @date 08/04/2024 - 15:33:41
 *
 * @param {{ children: any; }} param
 * @param {*} param.children // A react element node
 * @param {*} param.classes // element classNames
 * @returns {React.Component} // Accordion component
 */
const Accordion = ({ children, classes = "" }) => {
  return <div className={`w-full ${classes}`}>{children}</div>;
};

Accordion.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.string,
};
export default Accordion;
